import { ActionPersistData, ActionPersistResult } from "../action.model";
export const ACTION_PERSISTENCE_SERVICE = "ActionPersistenceService";

/**
 * Service implemented in client and used in Common to call the persistence route from the client
 */
export interface ActionPersistenceService<Context> {
    /**
     * Persist actions
     * @param actionPersistData 
     */
    persistActionData(actionPersistData: ActionPersistData<Context>[]): Promise<ActionPersistResult[]>;

}